import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CustomSelect, getData } from "../Commonfunction/CommonFunction";
import { toast } from "react-toastify";
import { FaCalculator, FaEye } from "react-icons/fa";
import TopHeading from "../common/TopHeading";
import { Field, Form, Formik } from "formik";
import CommonTable from "../common/CommonTable";
import CommonModal from "../common/CommonModal";
import PermissionMessage from "../common/PermissionMessage";
import CustomersFileHistoryFilter from "./CustomersFileHistoryFilter";
import "../../assets/style/CustomerfileView.css";
import { MdArrowCircleDown } from "react-icons/md";
import CustomersFileHistoryFilterForMonthWise from "./CustomersFileHistoryFilterForMonthWise";

export default function CustomerfileView() {
  const userType = localStorage.getItem("user_type");
  const { id } = useParams();
  const [tableData, setTableData] = useState([]);
  const [fileData, setFileData] = useState();
  const [filterData, setFilterData] = useState();
  const [singleData, setsingleData] = useState();
  const [firstYear, setFirstyear] = useState();
  const navigate = useNavigate();
  const [rowId, setRowId] = useState();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [showMultiModal, setShowMultiModal] = useState(false);
  const [showDownloaded, setShowDownloaded] = useState(false);
  const [pdfdw, setPdfDw] = useState();

  const [permissionMassage, setPermissionMassage] = useState(false);
  const [monthWiseRow, setMonthWiseRow] = useState();
  // const fileData = location.state?.fileData
  const fileYear = location.state?.year;
  const singleCountyData = async () => {
    try {
      const request_url = `/api/get-customer-file-by-customer-id/${id}`;
      const result = await getData(request_url);
      if (result.success) {
        // setTableData(result.data?.files);
        setFileData(result.data?.files);
        const FilterYearData = Object.keys(result.data?.files || {}).map(
          (year) => ({
            value: year,
            label: year,
          })
        );
        setFilterData(FilterYearData);
        if (fileYear) {
          const data = await result.data?.files[fileYear];
          // await form.setFileData("year", fileYear)
          await setFirstyear(fileYear);
          await setsingleData(result.data);
          await setTableData(data);
        } else {
          const data = await result.data?.files[FilterYearData[0].value];
          // await form.setFileData("year", "2025")
          await setFirstyear(FilterYearData[0].value);
          await setsingleData(result.data);
          await setTableData(data);
        }
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setRowId();
  };
  const handleMulitiFileClose = () => {
    setShowMultiModal(false);
  };
  const showDownloadedClose = () => {
    setShowDownloaded(false);
  };

  const columns = [
    // { field: "index", label: "No", width: 70 },
    {
      key: "customer_file_no",
      label: "File Number",
      minWidth: 170,
      flex: 1,
    },
    {
      key: "company_name",
      label: "Customer Name",
      minWidth: 200,
      flex: 1,
    },
    {
      key: "s_and_u_number",
      label: "S&U Number",
      minWidth: 180,
      flex: 1,
    },
    { key: "month", label: "Month", minWidth: 120, flex: 1 },
    { key: "year", label: "Year", minWidth: 120, flex: 1 },
    { key: "state_tax", label: "State Tax (%)", width: 150 },
    { key: "county_tax", label: "County Tax (%)", width: 170 },
    { key: "total_ga_tax", label: "Total Ga Tax (%)", width: 190 },
    { key: "vendor_comp_above", label: "Vendor Comp Above", width: 180 },
    { key: "vendor_comp_below", label: "Vendor Comp Below", width: 180 },
    {
      key: "action",
      label: "Action",
      width: 120,
      renderCell: (params) => (
        <>
          {userType === "CPA" && (
            <div className="usa-tooltip" data-position="top" title="Add Tax">
              <button
                type="button"
                className="action-button tax"
                onClick={() => {
                  navigate(
                    `/add-tax-by-view-customer-file/${params?.customer_file_no}`,
                    {
                      state: {
                        month: params?.month,
                        year: params?.year,
                        data: params,
                      },
                    }
                  );
                }}
              >
                <FaCalculator size={18} />
              </button>
            </div>
          )}
          <div className="usa-tooltip" data-position="top" title="View">
            <button
              type="button"
              className="action-button view"
              onClick={() => {
                navigate(`/tax-history-by-month/${params?.customer_id}`, {
                  state: { state: params, fileData: fileData },
                });
              }}
            >
              <FaEye size={18} />
            </button>
          </div>
          <div className="usa-tooltip" data-position="top" title="View">
            <button
              type="button"
              className="action-button download"
              onClick={() => {
                setPdfDw({
                  state: { state: params, fileData: fileData },
                });
                setShowDownloaded(true)
              }}
            >
              <MdArrowCircleDown size={18} />
            </button>
          </div>
        </>
      ),
    },
  ];

  const indexedRows =
    tableData?.length > 0 &&
    tableData?.map((data, index) => ({
      // index: index + 1,
      id: data.id,
      customer_file_no: data?.customer_file_no,
      company_name: data?.company_name,
      s_and_u_number: data?.s_and_u_number,
      month: data?.month,
      year: data?.year,
      state_tax: data?.state_tax,
      county_tax: data.county_tax,
      total_ga_tax: data.total_ga_tax,
      vendor_comp_above: data.vendor_comp_above,
      vendor_comp_below: data.vendor_comp_below,
      customer_id: data.customer_id,
      bank_account_no: data.bank_account_no,
      dba_name: data.dba_name,
      mobile_no: data.mobile_no,
      tax_head: data.tax_head,
      off_road_fuel: data.off_road_fuel,
      on_road_fuel: data.on_road_fuel,
      local_tax: data.local_tax,
      cbd_sales: data.cbd_sales,
      non_food: data.non_food,
      food_sales: data.food_sales,
      file_status: data.file_status,
      city: singleData?.city,
      state_name: singleData?.state_name,
      zipcode: singleData?.zipcode,
    }));

  useEffect(() => {
    singleCountyData();
  }, [firstYear]);
  return (
    <div>
      {/* Header Section */}
      <div className="section-header">
        <div className="left-section">
          <TopHeading
            className="top-heading-black"
            heading="Customer Files"
            isBackArrow="true"
          />
        </div>
        <div className="right-section">
          <Formik
            initialValues={{
              year: firstYear,
            }}
            enableReinitialize
          >
            {({ setFieldValue }) => (
              <Form>
                <div className="year-select">
                  <Field
                    name="year"
                    component={CustomSelect}
                    options={filterData}
                    onChange={(e) => {
                      setFieldValue("year", e.value);
                      const data = fileData[e.value];
                      setTableData(data);
                    }}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      {/* Table Section */}
      <div className="grid-row">
        <div className="grid-col-12">
          <CommonTable columns={columns} data={indexedRows || []} />
        </div>
      </div>

      {/* Modals */}
      {showModal && (
        <CommonModal
          open={showModal}
          onClose={handleClose}
          title="Customers File History By Month"
          size="add_large"
        >
          <CustomersFileHistoryFilter
            addTax={true}
            onClose={() => setShowModal(false)}
            monthWiseRow={monthWiseRow}
          />
        </CommonModal>
      )}

      {permissionMassage && (
        <PermissionMessage
          open={true}
          handleClose={() => setPermissionMassage(false)}
        />
      )}

      {showMultiModal && (
        <CommonModal
          open={showMultiModal}
          onClose={handleMulitiFileClose}
          title="Multiple File"
          size="extra_large"
        >
          {/* <MultiFIle /> */}
        </CommonModal>
      )}

      {showDownloaded && (
        <CommonModal
          open={showDownloaded}
          onClose={showDownloadedClose}
          title="Download PDF"
          size="extra_large"
        >
          <CustomersFileHistoryFilterForMonthWise monthData={pdfdw} isPDF={false}/>
        </CommonModal>
      )}
    </div>
  );
}
